import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	modalWrapper: {
		display        : "flex",
		alignItems     : "center",
		justifyContent : "center",
		zIndex         : "100"
	},
	root: {
		borderRadius: "2rem"
	},
	backgroundWrapper: {
		height       : "62vh",
		borderRadius : "2rem",
		background   : "unset"
	},
	imageWrapper: {
		display      : "flex",
		width        : "80%",
		minWidth     : "550px",
		minHeight    : "600px",
		height       : "50vh",
		// backgroundColor : "#fff",
		outline      : "none",
		borderRadius : "10px",
		position     : "relative"
	},
	image: {
		borderTopLeftRadius    : "10px",
		borderBottomLeftRadius : "10px",
		height                 : "100%",
		width                  : "55%",
		objectFit              : "contain",
		backgroundColor        : theme.other.colors.background.secondary
	},

	dialogContent: {
		display                 : "flex",
		flexDirection           : "column",
		height                  : "100%",
		overflow                : "hidden",
		background              : theme.other.colors.dialog.primary,
		borderRadius            : "2rem",
		borderBottomRightRadius : theme?.other.isMobile ? "0rem" : "2rem",
		borderBottomLeftRadius  : theme?.other.isMobile ? "0rem" : "2rem"
	},
	closeIcon: {
		width  : "3rem",
		margin : "1rem 1.5rem 1rem auto"
	},
	crossIcon: {
		position : "absolute",
		width    : "30px",
		top      : "1.5rem",
		left     : "1.5rem",
		cursor   : "pointer"
	},
	nextIcon: {
		width    : "40px",
		height   : "40px",
		position : "absolute",
		top      : "50%",
		right    : "-10%",
		cursor   : "pointer",
		opacity  : "0.5"
	},
	prevIcon: {
		width    : "40px",
		height   : "40px",
		position : "absolute",
		top      : "50%",
		left     : "-10%",
		cursor   : "pointer",
		opacity  : "0.5"
	},
	contentBoxWrapper: {
		display                 : "flex",
		flexDirection           : "column",
		flexGrow                : "1",
		position                : "relative",
		backgroundColor         : theme.other.colors.dialog.primary,
		borderBottomRightRadius : "1rem"
	},
	authorDetailsWrapper: {
		display      : "flex",
		alignItems   : "center",
		padding      : "2rem",
		height       : "80px",
		borderBottom : `1px solid ${ theme.other.colors.border.primary }`
	},
	dotsIcon: {
		transform : "scale(0.7)",
		width     : "40px",
		height    : "40px",
		cursor    : "pointer"
	},
	svgIconFollow: {
		transform : "scale(0.8)",
		cursor    : "pointer"
	},
	menuIconContainer: {
		display        : "flex",
		flexDirection  : "column",
		justifyContent : "center"
	},
	profileImage: {
		height       : "4rem",
		width        : "4rem",
		borderRadius : "50%",
		cursor       : "pointer"
	},
	nameWrapper: {
		display       : "flex",
		width         : "100%",
		marginLeft    : "1rem",
		flexDirection : "column"
	},
	name: {
		fontSize    : "1.5rem",
		fontWeight  : "500",
		marginRight : "10px",
		cursor      : "pointer"
	},
	headingWrapper: {
		display    : "flex",
		alignItems : "center"
	},
	verifiedIcon: {
		height : "15px",
		width  : "15px"
	},
	followersCount: {
		fontSize : "1.2rem",
		color    : "#757575"
	},
	emojiModalParent: {
		height: props?.displayEmoji ? "210px" : 0,

		"& .EmojiPickerReact li.epr-emoji-category>.epr-emoji-category-label": {
			color: `${ theme.other.colors.text.primary } !important`
		}
	},
	emojiModalWrapper: {
		width: "100%"
	},
	modalContent: {
		flex            : "0 0 auto",
		overflow        : "visible",
		maxWidth        : "90vw",
		backgroundColor : "transparent"
		// display : "flex"
	},
	mainWrapper: {
		overflow     : "hidden",
		borderRadius : "1rem",
		display      : "flex",
		background   : "none"
	},
	inputComment: {
		padding: "1rem 0"
	}

} ) );
